import { gql } from 'apollo-angular';

export const countryListQuery = gql`
  query CountryList {
    countryList {
      id
      name
    }
  }
`;

export const timezoneListQuery = gql`
  query TimezoneList {
    timezoneList {
      id
      zone
      utc_offset
    }
  }
`;

export const currencyListQuery = gql`
  query CurrencyList {
    currencyList {
      id
      value
    }
  }
`;

export const regionSettingsQuery = gql`
  query RegionSettings {
    regionSettings {
      deviceTime
      timezone {
        id
        zone
        utc_offset
      }
      currency {
        id
        value
      }
    }
  }
`;

export const languageSettingsQuery = gql`
  query LanguageSettings {
    languageSettings {
      id
      name
    }
  }
`;

export const regionSettingsMutation = gql`
  mutation UpdateRegionSettings($currencyId: ID!, $timezoneId: ID!) {
    updateRegionSettings(currencyId: $currencyId, timezoneId: $timezoneId) {
      timezone {
        id
        zone
        utc_offset
      }
      currency {
        id
        value
      }
    }
  }
`;

export const setDeviceTime = gql`
  mutation UpdateDeviceTime($deviceId: ID, $deviceTime: AWSDateTime!) {
    updateDeviceTime(deviceId: $deviceId, deviceTime: $deviceTime) {
      deviceTime
    }
  }
`;

export const languageListQuery = gql`
  query LanguageList {
    languageList {
      id
      name
    }
  }
`;

export const generalSettingsQuery = gql`
  query GeneralSettings {
    generalSettings {
      region {
        deviceTime
        timezone {
          id
          zone
          utc_offset
        }
        currency {
          id
          value
        }
      }
      language {
        id
        name
      }
      ui {
        background {
          abb
          custom
        }
        theme {
          abb
          custom
        }
        text {
          abb
          custom
        }
        logo {
          abb
          custom
        }
      }
    }
  }
`;

export const languageSettingsMutation = gql`
  mutation UpdateLanguageSettings($languageId: ID!) {
    updateLanguageSettings(languageId: $languageId) {
      id
      name
    }
  }
`;

export const utcQuery = gql`
  query Utc {
    regionSettings {
      timezone {
        utc_offset
      }
    }
  }
`;

export const uiSettingsQuery = gql`
  query UiSettings {
    uiSettings {
      background {
        abb
        custom
      }
      theme {
        abb
        custom
      }
      text {
        abb
        custom
      }
      logo {
        abb
        custom
      }
    }
    # uiSettings {
    #   background {
    #       abb
    #       custom
    #     }
    #     theme {
    #       abb
    #       custom
    #     }
    #     text {
    #       abb
    #       custom
    #     }
    #     logo {
    #       abb
    #       custom
    #     }
    # }
  }
`;

export const uiSettingsMutation = gql`
  mutation UpdateUiSettings(
    $abbBackgroundColor: Boolean!
    $customBackgroundColor: String
    $abbThemeColor: Boolean!
    $customThemeColor: String
    $abbTextColor: Boolean!
    $customTextColor: String
    $customLogo: String
  ) {
    updateUiSettings(
      abbBackgroundColor: $abbBackgroundColor
      customBackgroundColor: $customBackgroundColor
      abbThemeColor: $abbThemeColor
      customThemeColor: $customThemeColor
      abbTextColor: $abbTextColor
      customTextColor: $customTextColor
      customLogo: $customLogo
    ) {
      background {
        abb
        custom
      }
      theme {
        abb
        custom
      }
      text {
        abb
        custom
      }
      logo {
        abb
        custom
      }
    }
  }
`;

export const systemSettingsQuery = gql`
  query SystemSettings {
    systemSettings {
      appVersion
      scu200FwLatestVersion
      scu200List {
        id
        name
        serialNumber
        property {
          id
          name
        }
        firmware {
          id
          version
          releaseDate
          updateAvailable
          latestVersion
        }
      }
    }
  }
`;
